import React from 'react';
import {
  useConfig,
  useDynamicScript,
  useFeatureFlag,
  useFeatureFlags
} from '@mulesoft/exchange-react-hooks';
import {
  ASSETS_DEFINITIONS_VERSION,
  FEDERATED_ASSETS_DEFINITIONS_ENABLED
} from '~/domains/featureFlags/keys';

const noCachingQuery = `?v=${Date.now()}`;
const federatedContentCache = {};

async function loadComponent(scope, module) {
  await __webpack_init_sharing__('default');

  const container = window[scope];

  // eslint-disable-next-line camelcase
  await container.init(__webpack_share_scopes__.default);

  const factory = await window[scope].get(module);
  const Module = factory();

  return Module;
}

export const useFederatedModule = (module, file, customVersion) => {
  const config = useConfig();
  const { definitions } = config;
  const version = useFeatureFlags()[ASSETS_DEFINITIONS_VERSION];
  const isFederatedDefinitionsEnabled = useFeatureFlag(
    FEDERATED_ASSETS_DEFINITIONS_ENABLED
  );
  const noCacheQuery = version === 'dev' ? noCachingQuery : '';
  const { ready, failed } = useDynamicScript(
    `${
      isFederatedDefinitionsEnabled
        ? definitions?.federatedCDNPath
        : definitions?.exchangeCDNPath
    }/${isFederatedDefinitionsEnabled ? customVersion || version : version}/${`${module}.js`}${noCacheQuery}`
  );
  const [federatedContent, setFederatedContent] = React.useState(
    federatedContentCache[`${module}-${file}`] ?? null
  );
  const [federatedContentFailed, setFederatedContentFailed] =
    React.useState(false);

  React.useEffect(() => {
    if (ready && !federatedContent) {
      loadComponent(module, file)
        .then((result) => {
          setFederatedContent(result);

          federatedContentCache[`${module}-${file}`] = result;
        })
        .catch(() => setFederatedContentFailed(true));
    }
  }, [ready, module, file, federatedContent]);

  return {
    federatedContent,
    failed: failed || federatedContentFailed
  };
};
